<gc-accordion [expanded]="true">
  <ng-template #gcAccordionHeader>
    <gc-text [variant]="'bodyBold'">
      {{
        'installationReportV2.splicingAndMeasuringTab.fiberData.title'
          | translate
      }}
    </gc-text>
  </ng-template>
  <ng-template #gcAccordionBody>
    <div class="fiber-data">
      <div class="panelcard">
        <gc-text [variant]="'bodyBold'">{{
          'installationReportV2.splicingAndMeasuringTab.fiberData.panelcard.question'
            | translate
        }}</gc-text>
        <div class="radio-buttons">
          <gc-radio-button
            [name]="'buildingPanelcardFollowed'"
            [label]="
              'installationReportV2.splicingAndMeasuringTab.fiberData.panelcard.yes'
                | translate
            "
            [checked]="usesPanelCard()"
            (changed)="onPanelcardChange(true)"
          />
          <gc-radio-button
            [name]="'buildingPanelcardFollowed'"
            [label]="
              'installationReportV2.splicingAndMeasuringTab.fiberData.panelcard.no'
                | translate
            "
            [checked]="!usesPanelCard()"
            (changed)="onPanelcardChange(false)"
          />
        </div>
      </div>

      <div class="input-container">
        @for (input of inputFields; track input.label) {
          @if (input.label !== 'splitterPort') {
            <gc-input-field
              class="input-field"
              [label]="
                'installationReportV2.splicingAndMeasuringTab.fiberData.' +
                  input.label | translate
              "
              [supportingText]="
                input.description
                  ? ('installationReportV2.splicingAndMeasuringTab.fiberData.descriptions.' +
                      input.description | translate)
                  : ''
              "
              [placeholder]="
                'installationReportV2.splicingAndMeasuringTab.fiberData.placeholders.' +
                  input.placeholder | translate
              "
              [value]="fiberData()[input.label]"
              [disabled]="isFieldDisabled()(input.undisableable)"
              [type]="input.type ?? 'text'"
              (changed)="onFieldChange(input.label, $event)"
            />
          } @else {
            <gc-dropdown-button
              class="input-field"
              [label]="
                'installationReportV2.splicingAndMeasuringTab.fiberData.' +
                  input.label | translate
              "
              [placeholder]="
                'installationReportV2.splicingAndMeasuringTab.fiberData.placeholders.' +
                  input.placeholder | translate
              "
              [activeItemId]="fiberData()[input.label]"
              [disabled]="isFieldDisabled()(input.undisableable)"
              (listItemClicked)="onFieldChange(input.label, $event)"
            >
              @for (option of splitterPortValues; track option.id) {
                <gc-list-item [id]="option.id" [label]="option.label" />
              }
            </gc-dropdown-button>
          }
        }
      </div>
    </div>
  </ng-template>
</gc-accordion>
